import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from 'Components/UI/Typography';
import HelperText from 'Components/UI/Accounts/AccountApplication/HelperText';
import Switch from 'Components/ComponentLibrary/Components/Uncategorized/Switch';

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
  },
  title: {
    flexBasis: '70%',
    flexGrow: 1,
  },
  helperText: {
    paddingBottom: theme.spacing(0.5),
  },
});

const YesNoQuestionWithHelperText = ({
  classes,
  className,
  value,
  onChange,
  label,
  fullWidth,
  helperText,
  ...rest
}) => {
  const handleChange = (e) => {
    e.target.checked = !value;
    return onChange(e);
  };
  return (
    <div className={classNames(classes.root, className)} {...rest}>
      <Typography variant="h6" className={classes.title}>
        {label}
        <HelperText iconClassName={classes.helperText} text={helperText} />
      </Typography>
      <Switch
        onChange={handleChange}
        selected={value}
      />
      <input hidden value={value} onClick={onChange} />
    </div>
  );
};

YesNoQuestionWithHelperText.defaultProps = {
  classes: {},
  className: '',
  fullWidth: false,
  value: null,
};

YesNoQuestionWithHelperText.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  value: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string.isRequired,
};

export default withStyles(styles)(YesNoQuestionWithHelperText);
